
export class ConnectedDeviceSetting {
  key: string;
  value: string;

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.value = payload.value;
    }
  }
  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createConnectedDeviceSettings(result: Array<any>): ConnectedDeviceSetting[] {
    const connectedDeviceSettings = new Array<ConnectedDeviceSetting>();
    if (result) {
      result.map((connectedDeviceSetting) => {
        connectedDeviceSettings.push(new ConnectedDeviceSetting(connectedDeviceSetting));
      });
    }
    return connectedDeviceSettings;
  }
}

export class ConnectedDeviceSettingInput {
  key: string;
  value: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.value = payload.value;
    }
  }
}

export class ConnectedDeviceAppVersions {
  latestAppVersion: string;
  minAppVersion: string;

  constructor(payload?: any) {
    if (payload) {
      this.latestAppVersion = payload.latestAppVersion;
      this.minAppVersion = payload.minAppVersion;
    }
  }
}
